import { useMutation } from '@tanstack/react-query';
import { getAppConfig } from '../../../config';
import { loadCredentials } from '../../../apiClient';
import { ChatMessage } from './useChatMessages';

type SendChatInput = {
  messages: ChatMessage[];
  conversationId?: string | null;
};

type SendChatResponse = ChatMessage & { conversationId: string };

export function useSendChatMessage(organizationId: string | undefined, locationId: string | undefined) {
  return useMutation({
    mutationFn: async (input: SendChatInput): Promise<SendChatResponse> => {
      const { idToken } = loadCredentials();
      const response = await fetch(
        `${getAppConfig().apiUrl}/ai-assistant/chat`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            authorization: idToken,
            'x-organization-id': organizationId!,
            'x-location-id': locationId!,
            'x-timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
          },
          body: JSON.stringify({
            messages: input.messages,
            ...(input.conversationId && {
              conversationId: input.conversationId,
            }),
          }),
        },
      );

      if (!response.ok) {
        const body = await response.json().catch(() => null);
        throw new Error(body?.message || `Request failed (${response.status})`);
      }

      return response.json();
    },
  });
}
